import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, Eye, Sparkles } from "lucide-react";
import http from "@/api";
import { useApp } from "@/context";

const API_BASE = process.env.REACT_APP_BACKEND_URL || "";
const src = (u) => (u && u.startsWith("/") ? `${API_BASE}${u}` : u);

export default function Designs() {
  const { lang } = useApp();
  const ar = lang !== "en";
  const [designs, setDesigns] = useState(null);

  useEffect(() => {
    http.get("/ai/designs/gallery?limit=40")
      .then(({ data }) => setDesigns(data.designs || []))
      .catch(() => setDesigns([]));
  }, []);

  return (
    <div className="max-w-3xl mx-auto px-4 py-6 space-y-4" data-testid="designs-gallery-page">
      <div className="text-center space-y-1.5">
        <h1 className="text-2xl font-black">{ar ? "🎨 معرض تصاميم عملائنا" : "🎨 Customer designs gallery"}</h1>
        <p className="text-xs opacity-60 max-w-md mx-auto">
          {ar
            ? "تصاميم حقيقية صمّمها عملاؤنا بالذكاء الاصطناعي على منتجاتنا — اضغط أي تصميم واطلبه بنفس الشكل أو صمّم لمستك الخاصة"
            : "Real designs our customers created with AI — tap any design to order it or create your own"}
        </p>
      </div>
      {designs === null ? (
        <div className="py-12 flex justify-center"><Loader2 className="animate-spin text-emerald-700" size={26} /></div>
      ) : designs.length === 0 ? (
        <div className="py-12 text-center text-sm opacity-60" data-testid="designs-empty">
          {ar ? "لا توجد تصاميم مشتركة بعد — كن أول من يصمّم ويشارك! ✨" : "No shared designs yet — be the first! ✨"}
        </div>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-3" data-testid="designs-grid">
          {designs.map((d) => (
            <Link key={d.id} to={`/design/${d.id}`}
                  className="rounded-2xl border overflow-hidden bg-white hover:shadow-md transition-shadow"
                  style={{ borderColor: "var(--border)" }} data-testid={`design-card-${d.id}`}>
              <div className="relative">
                <img src={src(d.image)} alt="" className="w-full aspect-square object-cover" loading="lazy" />
                {d.featured && (
                  <span className="absolute top-1.5 start-1.5 text-[9px] font-black px-1.5 py-0.5 rounded-full bg-amber-400 text-amber-950">
                    ⭐ {ar ? "مميز" : "Featured"}
                  </span>
                )}
                <span className="absolute bottom-1.5 end-1.5 text-[9px] px-1.5 py-0.5 rounded-full bg-black/55 text-white flex items-center gap-0.5">
                  <Eye size={9} /> {d.views || 0}
                </span>
              </div>
              <div className="p-2 space-y-0.5">
                {d.label && <div className="text-[10px] opacity-70 truncate">{d.label}</div>}
                <div className="text-[11px] font-bold truncate">{ar ? d.product.name_ar : d.product.name_en || d.product.name_ar}</div>
                {Number(d.product.price_sar) > 0 && (
                  <div className="text-xs font-black text-emerald-800">
                    {Number(d.product.price_sar).toLocaleString("en")} {ar ? "ر.ق" : "QAR"}
                  </div>
                )}
              </div>
            </Link>
          ))}
        </div>
      )}
      <div className="text-center pt-1">
        <Link to="/shop" className="btn-primary !py-2.5 !px-6 text-sm inline-flex items-center gap-1.5" data-testid="designs-shop-btn">
          <Sparkles size={14} /> {ar ? "صمّم لمستك الخاصة الآن" : "Create your own now"}
        </Link>
      </div>
    </div>
  );
}
